import { InjectionToken } from "@angular/core";
import { environment } from "src/environments/environment";
import { AppConfig } from "./app-config";

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config', {
    providedIn: 'root',
    factory: () => environment
});